import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getTemplateDetail = createAsyncThunk('notification/getTemplateDetail', async (code, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/notifications/templates/${code}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getNotificationsTemplate = createAsyncThunk(
  'notification/getNotificationsTemplate',
  async (payload, thunkAPI) => {
    const { page, limit = 10 } = payload;

    try {
      const response = await axiosInstance.get(`/notifications/templates?limit=${limit}&page=${page}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const createPlayerNotification = createAsyncThunk(
  'notification/createPlayerNotification',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/notifications/players/token`, {
        token: payload,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const sendNotification = createAsyncThunk('notification/sendNotification', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/backoffices/notifications`, { ...payload });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
